<template>
  <div>
    <div class="flex items-center gap-8 mb-16">
      <TickCircleOutlineIcon color="#229150" :width="44" :height="44" aria-hidden="true" />
      <h1 class="font-medium text-m1">{{ titleForBasicUsers }}</h1>
    </div>
    <p class="text-body mb-24">Search for more sitters or continue the conversation in messages.</p>
    <Button value="Upgrade to Message" variant="primary" size="medium" class="w-full mb-16" href="/upgrade/pricing" />
    <Button value="Search for Sitters" variant="outlined" size="medium" class="w-full" href="/availability/search" />
  </div>
</template>

<script lang="ts">
import TickCircleOutlineIcon from '@/graphics/icons/TickCircleOutlineIcon.vue';
import Button from '@/components/button/Button.vue';

export default {
  name: 'RecruitJobShared',
  components: { TickCircleOutlineIcon, Button },
  props: {
    recipientUuid: {
      type: String,
      required: true,
    },
    recipientName: {
      type: String,
      required: true,
    },
  },
  computed: {
    titleForBasicUsers(): string {
      return `Job shared with ${this.recipientName}`;
    },
  },
};
</script>
